<div class="container">
  <div class="downloads-content">
    <h2>Downloads</h2>
    
    <div class="data-availability-section">
      <h3>GWAS1-6 Data Availability</h3>
      <p>
        Summary statistics for GWAS analyses have been deposited at DRYAD 
        <a href="https://datadryad.org/dataset/doi:10.5061/dryad.3xsj3txpx" target="_blank" rel="noopener noreferrer">
          https://datadryad.org/dataset/doi:10.5061/dryad.3xsj3txpx
        </a> as reported in the publication authored by the GEM-HD consortium 
        (<a href="https://pubmed.ncbi.nlm.nih.gov/40490511/" target="_blank" rel="noopener noreferrer">PMID: 40490511</a>).
      </p>
      
      <p>
        Individual level genetic data cannot be deposited into a public or controlled repository due to restrictions 
        imposed by the General Data Protection Regulation of the European Union and the CHDI Foundation, sponsor of 
        the Enroll-HD Platform. These data can be obtained by qualified investigators given their institutional 
        assurance of subject confidentiality and compliance with GDPR requirements with respect to personal data 
        by emailing <a href="mailto:info@chdifoundation.org?subject=GWAS123456%20data">info&#64;chdifoundation.org</a> 
        with the words "GWAS123456 data" in the subject line.
      </p>
    </div>

    <div class="data-availability-section">
      <h3>Enroll-HD WGS+ Data Availability</h3>
      <p>
        Data can be requested from the Enroll-HD
        <a href="https://enroll-hd.org/for-researchers/access-data-biosamples/" target="_blank" rel="noopener noreferrer">Access</a>
        page. We anticipate that summary statistics will be available in 2026 through a dedicated download.
        We will provide download information when this time comes.
      </p>
    </div>
  </div>
</div>